var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new moon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M19.6534 16.7379C19.8623 16.4012 19.5771 15.9904 19.181 15.9982C19.1208 15.9994 19.0605 16 19 16C14.0294 16 10 11.9706 10 7.00001C10 5.91489 10.192 4.87462 10.544 3.91134C10.6799 3.53923 10.3843 3.13572 9.998 3.22348C5.99102 4.13368 3 7.71755 3 12C3 16.9706 7.02944 21 12 21C15.2321 21 18.0663 19.2963 19.6534 16.7379Z",
    stroke: "#DFDFDF",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.da2c9564de423302ac668a000218331b.svg";
export { ForwardRef as ReactComponent };